import { Component } from '@angular/core';
import { ModalService } from '../../modal.service';

@Component({
  selector: 'shell-answers-verified',
  templateUrl: './answers-verified.component.html',
  styleUrls: ['./answers-verified.component.scss'],
})
export class AnswersVerifiedComponent {
  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.close();
  }
}
